<template>
  <section
    class="hero is-link is-fullheight-with-navbar"
    style="
      background-size: cover;
      background-position: center;
    "
    :style="{
      'background-image': 'url(' + dunes + ')'
    }"
  >
    <container-box>
      <form @submit.prevent="submit">
        <label class="label is-large">Oubli de mot de passe</label>
        {{ queryToken }}
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="email"
              placeholder="Email"
              v-model="email"
              autocomplete="email"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-envelope"></i>
            </span>
            <span class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
          </p>
        </div>
        <template v-if="withToken">
          <div class="field">
            <p class="control has-icons-left">
              <input
                class="input"
                type="password"
                placeholder="Nouveau mot de passe"
                v-model="newPassowrd"
                autocomplete="new-password"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </p>
          </div>
          <div class="field">
            <p class="control has-icons-left">
              <input
                class="input"
                type="password"
                placeholder="Confirmation du mot de passe"
                v-model="confirmPassword"
                autocomplete="off"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </p>
          </div>
        </template>
        <div class="field is-grouped">
          <p class="control">
            <button
              class="button is-primary"
              :class="{ 'is-loading': loading }"
            >
              Envoyer
            </button>
          </p>
          <p class="control">
            <router-link class="button is-light" :to="{ name: 'Login' }">
              Annuler
            </router-link>
          </p>
        </div>
      </form>
    </container-box>
  </section>
</template>

<script>
import blueDunes from "@/assets/blueDunes.svg";
import ContainerBox from "@/components/ContainerBox";

export default {
  components: { ContainerBox },
  data() {
    return {
      dunes: blueDunes,
      email: "",
      newPassowrd: "",
      confirmPassword: "",
      loading: false
    };
  },
  methods: {
    submit() {
      this.loading = !this.loading;
      this.validateForm();
      if (this.newPassowrd === this.confirmPassword) {
        this.loading = !this.loading;
      }
    },
    validateForm() {
      if (this.newPassowrd === this.confirmPassword) {
        return true;
      }
    }
  },
  computed: {
    queryToken() {
      return this.$route.query.token;
    },
    withToken() {
      return !!this.queryToken;
    }
  }
};
</script>
